let articles
const reInit = () => {
    ScrollTrigger.refresh()
    articles = [...document.querySelectorAll(".blog-card")];
    //initializeProductEventListeners()
}

let endlessScroll;
const initializeScroll = () => {
    endlessScroll = new Ajaxinate({
        container: '#blog-grid',
        pagination: '#AjaxinatePagination',
        offset: 10000,
        callback: myAjaxinateCallBack
    });

    function myAjaxinateCallBack(){
        console.log('Ajaxinate has finished loading new content!');
        reInit()
    }
}


document.addEventListener("DOMContentLoaded", function() {
    initializeScroll()
});
